import React from "react"
import PropTypes from "prop-types";
import Styles from "../styles/Grid.module.css"

const Grid = ({ children, size, mobileStack = false }) => {
  
  const prepareClass = (size, mobileStack) => {
    let className = Styles.row;
    if (size === "half") {
      className = Styles.half;
    } else if (size === "third") {
      className = Styles.third;
    } else if (size === "two-thirds") {
      className = Styles.twoThirds;
    }
    if (mobileStack) {
      className = className + " " + Styles.mobileStack;
    }
    return className
  }

  return (
    <div className={prepareClass(size, mobileStack)}>
      {children}
    </div>
  );
};

export default Grid

Grid.propTypes = {
  size: PropTypes.string,
};